interface SidebarFooterProps {
  isCollapsed: boolean;
}

/**
 * "Powered By AIT GLOBAL", per the SidebarFooter in niraxobid.md section 23.6.
 *
 * Section 9.1 also asks for user identity and a Logout button here, but 23.6's
 * own implementation has neither -- and both already live in the header's user
 * dropdown, which is where the comp puts them. Two Logout buttons would be
 * redundant.
 */
export function SidebarFooter({ isCollapsed }: SidebarFooterProps) {
  return (
    <div className="sidebar__footer">
      {!isCollapsed && <span>Powered By AIT GLOBAL</span>}
    </div>
  );
}
